package fr.frux.shared.domain.model

import fr.frux.core.maps.Location

/** Nature d'un lieu trouvé par la recherche (#394). Le zoom cible de la carte en dépend. */
enum class PlaceType { MUNICIPALITY, STREET, ADDRESS, LOCALITY, POI }

/** Un lieu géocodé : nom court, complément affichable et position. */
data class Place(
    val label: String,
    val detail: String?,
    val type: PlaceType,
    val location: Location,
)
